import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const UsersQuery = gql`
  query {
    users {
      id
      email
      language
      privileges
      countries {
        id
        name
      }
    }
  }
`;

const CreateUserMutation = gql`
  mutation($user: CreateUserInput!) {
    createUser(user: $user) {
      id
    }
  }
`;

const UpdateUserMutation = gql`
  mutation($id: ID!, $user: UpdateUserInput!) {
    updateUser(id: $id, user: $user) {
      id
    }
  }
`;

const DeleteUserMutation = gql`
  mutation($id: ID!) {
    deleteUser(id: $id) {
      id
    }
  }
`;

const ChangeUserPasswordMutation = gql`
  mutation($id: ID!, $pw: String!) {
    changeUserPassword(id: $id, pw: $pw)
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

class GetUsersQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
  render() {
    const { users, createUser, updateUser, deleteUser, changeUserPassword }: any = this.props;
    return this.props.children({ users, createUser, updateUser, deleteUser, changeUserPassword });
  }
}

export default compose(
  graphql<IInputProps, Response>(UsersQuery, {
    name: 'users',
  }),
  graphql<IInputProps, Response>(CreateUserMutation, {
    name: 'createUser'
  }),
  graphql<IInputProps, Response>(UpdateUserMutation, {
    name: 'updateUser'
  }),
  graphql<IInputProps, Response>(DeleteUserMutation, {
    name: 'deleteUser'
  }),
  graphql<IInputProps, Response>(ChangeUserPasswordMutation, {
    name: 'changeUserPassword'
  })
)(GetUsersQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Users/Users.tsx